module.exports = __webpack_public_path__ + "static/wand_of_enemy_detection-e5da71ff55f7e0e565d4644c0dc75e46.jpeg";